import { previewDashboardSearchSchema } from '@/config/commonSearch';

export const campaignPlannerSearchSchema = previewDashboardSearchSchema.extend(
    {},
);

export { CampaignPlanner } from './CampaignPlanner';
